var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progressDataDebug"
  }, [_c('h2', [_vm._v("EDIT PROGRESS DATA")]), _c('p', [_vm._v("\n    To edit progress data simply enter (and set) the activityId of the one you want to take.\n    Please note, for now, you cannot move backwards in the curriculum.\n  ")]), _c('div', {
    staticClass: "debuginput"
  }, [_c('label', [_vm._v("\n      ASN:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.asn,
      expression: "asn"
    }],
    attrs: {
      "name": "asn",
      "type": "number",
      "min": "0",
      "step": "1",
      "number": ""
    },
    domProps: {
      "value": _vm.asn
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.asn = $event.target.value;
      }
    }
  })]), _c('button', {
    staticClass: "submitrewrite",
    attrs: {
      "id": "updateProgress",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.updateProgress($event);
      }
    }
  }, [_vm._v("\n      Update Progress\n    ")]), _c('span', {
    class: ['updateResult', _vm.updateProgressResult]
  }, [_vm._v(_vm._s(_vm.updateMessage))])]), _c('div', {
    staticClass: "debuginput"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showSpotCheckList($event);
      }
    }
  }, [_vm._v("\n      List Spot Checks\n    ")]), _c('span', {
    staticClass: "spotCheckList"
  }, [_vm._v(_vm._s(_vm.spotCheckAsns))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }